import { motion, AnimatePresence } from "framer-motion";

export const Loader = ({ show }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        key="loader"
        className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#120D0D]"
        exit={{ opacity: 0 }}
        transition={{ duration: 0.7, ease: "easeInOut" }}
        data-testid="page-loader"
      >
        <div className="relative flex items-center justify-center">
          <div className="absolute w-56 h-56 radial-gold rounded-full animate-pulse" />
          {/* rotating gold ring */}
          <div
            className="absolute w-36 h-36 rounded-full border-2 border-transparent"
            style={{
              borderTopColor: "#F5C542",
              borderRightColor: "#F28C28",
              animation: "spinRing 1s linear infinite",
            }}
          />
          <motion.img
            src="/manga-symbol.png"
            alt="Grupo Manga"
            className="w-20 h-20 object-contain gold-glow"
            initial={{ scale: 0.85 }}
            animate={{ scale: [0.85, 1, 0.85] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>
        <motion.p
          className="mt-10 font-display text-sm tracking-[0.4em] uppercase text-white/50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Grupo Manga
        </motion.p>
      </motion.div>
    )}
  </AnimatePresence>
);
